import {SearchSortType} from 'views/search/stores/search';

export enum EventTypeName {
    Call = 'call',
    Chat = 'chat',
    Feedback = 'feedback',
    Email = 'email',
}

export interface EventType {
    name: EventTypeName;
    id: number;
    tableName: string;
}

export interface EventTranscription {
    start: number;
    end: number;
    transcript: string;
    channel: string;
}

export interface EventActor {
    person_id: number;
    external_id: string;
    type: string;
    contact_type: string;
    first_name: string;
    last_name?: string;
    full_info: string;
}

export enum EventTextFieldOption {
    AllFields = 'all_fields',
    EventText = 'event_text',
    EventAgentText = 'event_agent_text',
    EventCustomerText = 'event_customer_text',
    EventBotText = 'event_bot_text',
    EventSystemText = 'event_system_text',
}

export interface EventTextFields {
    [EventTextFieldOption.EventText]: string;
    [EventTextFieldOption.EventAgentText]: string;
    [EventTextFieldOption.EventCustomerText]: string;
    [EventTextFieldOption.EventBotText]: string;
    [EventTextFieldOption.EventSystemText]: string;
}
export type EventTextField = keyof EventTextFields;

export interface BaseEventTextFields {
    [EventTextFieldOption.EventText]: string;
    [EventTextFieldOption.EventAgentText]: string;
    [EventTextFieldOption.EventCustomerText]: string;
}

export interface ChatEventTextFields {
    [EventTextFieldOption.EventBotText]: string;
    [EventTextFieldOption.EventSystemText]: string;
}

export interface CallEventTextFields {
}

export interface FeedbackEventTextFields {
}

export interface EmailEventTextFields {
}

export interface BaseEvent extends BaseEventTextFields {
    id: number;
    event_id: number;
    event_type_name: EventTypeName;
    eventTypeName: EventTypeName;
    event_datetime: string;
    event_lang: string;
}

export interface BaseEventWithChannel extends BaseEvent {
    channel_name: string;
    channel_shortname: string;
}

export interface CallEvent extends BaseEvent {

}

export interface ChatEvent extends BaseEvent {

}

export interface FeedbackEvent extends BaseEvent {

}

export interface EmailEvent extends BaseEvent {

}

export interface Event extends BaseEventWithChannel {
    event_external_id: string;
    event_hash: string;
    event_call_id?: string;
    event_call_audio_uri?: string;
    event_call_duration?: number;
    event_transcription?: EventTranscription[];
    event_call_type?: any;
    event_metadata?: any;
    customer_id: number;
    customer_external_id: string;
    customer_first_name?: any;
    customer_last_name?: any;
    customer_full_info: string;
    customer_type?: any;
    agent_id: number;
    agent_external_id: string;
    agent_first_name: string;
    agent_last_name: string;
    agent_full_info: string;
    agent_active: boolean;
    event_actors: EventActor[];
}

export interface AnyBaseEvent extends
    BaseEvent,
    Partial<ChatEventTextFields>,
    Partial<CallEventTextFields>,
    Partial<FeedbackEventTextFields>,
    Partial<EmailEventTextFields> { }

export interface AnyBaseEventWithChannel extends AnyBaseEvent, BaseEventWithChannel, Event {}

export interface ConcordanceData extends BaseEvent, BaseEventWithChannel, Event {
    key_id: number;
    left_print: string;
    right_print: string;
    query: string;
}

export interface CallDataConversation {
    channel: string;
    start: number;
    end: number;
    transcript: string;
}

export interface CallData {
    conversation: CallDataConversation[];
    sentences: string[];
}

export type WordCloudData = [string, number, number?];
export type SortTypeFieldChoice = [SearchSortType, string];
